import { DSFlex, DSSpacer, DSText } from '@zoe/ds-web'
import React from 'react'
import type { ResponsiveImageType } from 'react-datocms'

import type { FragmentComponent } from '@/types/graphql'

import { DatoImage } from '@/components/elements/global/DatoImage'

export type QuoteWithAuthorRecord = {
  __typename: 'QuoteWithAuthorRecord'
  id: string
  quote: string
  author?: string
  image?: {
    responsiveImage: ResponsiveImageType
  }
}

const fragment = `
  fragment QuoteWithAuthorBlockFragment on QuoteWithAuthorRecord {
    __typename
    id
    quote
    author
    image {
      responsiveImage {
        alt
        aspectRatio
        base64
        bgColor
        height
        sizes
        src
        srcSet
        title
        webpSrcSet
        width
      }
    }
  }
`

export const QuoteWithAuthorBlock: FragmentComponent<{}, QuoteWithAuthorRecord> = ({ record }) => {
  return (
    <DSFlex direction="row" alignItems="flex-start" gap={16}>
      {record.image && (
        <div style={{ width: '64px', height: '64px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
          <DatoImage data={record.image.responsiveImage} />
        </div>
      )}
      <DSFlex direction="column">
        {record.quote
          ?.split(/\n\s*\n/)
          .filter(Boolean)
          .map((paragraph, idx) => (
            <React.Fragment key={idx}>
              {idx > 0 && <DSSpacer direction="vertical" size={8} />}
              <DSText as="p" variant="fluid-paragraph-200">
                {paragraph}
              </DSText>
            </React.Fragment>
          ))}
        {record.author && (
          <>
            <DSSpacer direction="vertical" size={8} />
            <DSText as="p" variant="fluid-label-100" color="secondary">
              {record.author}
            </DSText>
          </>
        )}
      </DSFlex>
    </DSFlex>
  )
}

QuoteWithAuthorBlock.fragment = fragment
QuoteWithAuthorBlock.recordName = 'QuoteWithAuthorRecord'
